import StepperNav from "./stepperNav";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next'


const SelectServer = ({step, setStep, setSeverDetails, type, onClose}) => {
    const [isValid, setIsValid] = useState(type);
    const { t } = useTranslation("settings");

    useEffect(() => {
        if (type) {
            setIsValid(true);
        }
    }, [type])
    
    const onOptionChange = (e) => {
        setSeverDetails(prevServer => ({
            ...prevServer, // copy the existing properties of 'server'
            type: e.target.value // update the 'type' property
          }));
          
        setIsValid(true);
    }


    return ( 
        <div className="w-full font-normal">

            {step==1 &&

                <>
                <span className="block text-sm font-semibold text-gray-700">1. {t('device_management.server_setup.select_server')}</span>
                
                <div className="flex flex-col gap-4 mt-2 ml-2 text-sm ">
                  <div className="">
                    <label className="inline-flex items-center gap-2 cursor-pointer">
                      <input type="radio" name="server" value="influxdbs" 
                      className="w-4 h-4 cursor-pointer accent-emerald-700 hover:accent-emerald-700" 
                      checked={type === 'influxdbs' || type === 'influxdb'}
                      onChange={onOptionChange}
                      />
                      {/* IOT Database */}
                      {t('device_management.server_setup.iot_database')}
                    </label>
                  </div>

                  <div className="">
                    <label className="inline-flex items-center gap-2 cursor-pointer">
                        <input type="radio" name="server" value="huawei-cloud" 
                            className="w-4 h-4 cursor-pointer accent-emerald-700"
                            checked={type === 'huawei-cloud'}
                            onChange={onOptionChange}
                        />
                        {/* Huawei */}
                        {t('device_management.server_setup.huawei')}
                    </label>
                  </div>
                </div>

                 {/* <StepperNav step={step} setStep={setStep} isValid={isValid}  prev="Cancel" next={'Configure Server'} onClose={onClose} /> */}
                 <StepperNav step={step} setStep={setStep} isValid={isValid}  prev={`${t('device_management.server_setup.cancel')}`} next={`${t('device_management.server_setup.configure')}`} onClose={onClose} />

                </>
            }

            </div>
     );
}
 
export default SelectServer;